
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonforeventinpune() {



    const cardData =
    {
        keyword: 'Bus on Rent For Event in Pune',
        heading: 'Amruta Travels: Bus on Rent For Event in Pune',
        headingDescription: 'Amruta Travels offers Bus on Rent for Events in Pune, delivering dependable and comfortable transportation solutions tailored for various occasions. Whether it is a corporate seminar, wedding celebration, exhibition, or private gathering, our well-maintained fleet ensures a seamless and enjoyable journey for all attendees. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make event transportation stress-free and efficient. Choose from our range of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your event bus with Amruta Travels and ensure a memorable experience for your guests!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

    "services": [
    {
      "name": "Bus on Rent for Wedding Evening Pune",
      "description": "Amruta Travels offers specialized bus rental services for wedding evenings in Pune. Whether you're arranging transportation for guests between the venue and the reception, or need a dedicated shuttle service, our fleet ensures that everyone arrives on time, comfortably, and in style."
    },
    {
      "name": "Bus Rental for Wedding Party",
      "description": "Make your wedding party transportation hassle-free with Amruta Travels' bus rental services. Our buses can accommodate large groups of guests, providing a comfortable, safe, and timely ride to and from your wedding venues. Choose from a variety of buses based on the number of guests and the wedding itinerary."
    },
    {
      "name": "Private Bus Service on Rent for Event in Pune",
      "description": "Amruta Travels offers private bus services on rent for various events in Pune. From corporate events to weddings and private functions, our buses offer luxury, comfort, and timely service to ensure your event goes smoothly. Customizable packages are available to meet your specific needs."
    },
    {
      "name": "Bus on Hire for Party in Pune",
      "description": "Planning a party in Pune? Rent a bus from Amruta Travels to transport your guests comfortably to and from the party venue. Our buses come equipped with amenities to ensure a relaxing and enjoyable ride, so everyone can focus on the celebration."
    },
    {
      "name": "Pune to Bhimashankar Bus Tour Package",
      "description": "Experience a spiritual journey from Pune to Bhimashankar with Amruta Travels' bus tour package. Our 32-seater and larger buses are equipped with modern amenities to ensure a smooth and peaceful ride. This package includes flexible schedules and knowledgeable drivers to enhance your visit to the temple."
    },
    {
      "name": "Pune to Mahabaleshwar Bus Tour Package",
      "description": "Escape to the serene hills of Mahabaleshwar with Amruta Travels’ bus tour package from Pune. Whether it’s for a family trip or a corporate outing, our buses are perfect for groups of any size. Enjoy scenic views, safe and comfortable travel, and a seamless journey to this popular hill station."
    },
    {
      "name": "Pune to Goa Bus Tour Packages",
      "description": "Plan a memorable trip to Goa with Amruta Travels’ bus tour packages from Pune. Our buses are ideal for group travel, with AC and non-AC options available to suit your preferences. Enjoy a relaxing ride as you make your way to the beautiful beaches of Goa with your friends or family."
    },
    {
      "name": "32, 35, 40, 45, 50 Seater Bus on Rent in Pune",
      "description": "Amruta Travels offers a wide range of bus rental options, including 32, 35, 40, 45, and 50-seater buses, catering to your group transportation needs. Whether it’s for a wedding, corporate outing, or sightseeing tour, our buses provide ample space, comfort, and reliability for a seamless experience."
    },
    {
      "name": "Pune to Shirdi Bus Package",
      "description": "For a spiritual trip to Shirdi, Amruta Travels offers a convenient bus package from Pune. Our buses are equipped with AC and non-AC options, providing a comfortable and safe ride to one of the most revered pilgrimage sites in Maharashtra. Our services include flexible schedules and professional drivers for a smooth experience."
    },
    {
      "name": "Pune to Ajanta Ellora Bus on Rent",
      "description": "Explore the historic caves of Ajanta and Ellora with Amruta Travels' bus rental services from Pune. We provide comfortable buses with experienced drivers for a smooth journey to these UNESCO World Heritage sites. Our fleet is ideal for groups looking to experience the cultural wonders of Maharashtra."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Bus Package",
      "description": "Embark on a spiritual journey with Amruta Travels’ Pune to Ashtavinayak Darshan bus package. Our buses provide a comfortable and convenient way to visit all the Ashtavinayak temples, with professional drivers and flexible schedules ensuring a smooth and enriching travel experience."
    }
  ],
  "tableData": [
    ["Bus on Rent for Wedding Evening Pune", "Bus Rental for Wedding Party"],
    ["Private Bus Service on Rent for Event in Pune", "Bus on Hire for Party in Pune"],
    ["Pune to Bhimashankar Bus Tour Package", "Pune to Mahabaleshwar Bus Tour Package"],
    ["Pune to Goa Bus Tour Packages", "32, 35, 40, 45, 50 Seater Bus on Rent in Pune"],
    ["Pune to Shirdi Bus Package", "Pune to Ajanta Ellora Bus on Rent"],
    ["Pune to Ashtavinayak Darshan Bus Package", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Convenient Group Transportation",
    "WhyChoosedescription": "Amruta Travels offers Bus on Rent for Event in Pune, providing smooth and efficient transport for all types of events—corporate, social, cultural, or private gatherings."
  },
  {
    "WhyChooseheading": "Ideal for All Event Types",
    "WhyChoosedescription": "Whether it’s a conference, exhibition, concert, or family celebration, our buses are perfect for transporting guests or participants to and from the venue comfortably and on time."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our trained drivers are punctual, professional, and familiar with major event venues across Pune, ensuring a reliable and hassle-free experience for all passengers."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide budget-friendly bus rental services for events with clear, upfront pricing and no hidden costs—making event transportation easy to manage."
  },
  {
    "WhyChooseheading": "Clean, Air-Conditioned Buses",
    "WhyChoosedescription": "Our fleet of well-maintained buses offers clean interiors, comfortable seating, and air conditioning to ensure your guests travel in comfort and style."
  },
  {
    "WhyChooseheading": "Flexible Scheduling and Custom Routes",
    "WhyChoosedescription": "We offer flexible pickup/drop-off times and fully customizable routes to accommodate your event schedule and logistics seamlessly."
  },
  {
    "WhyChooseheading": "Fleet for All Group Sizes",
    "WhyChoosedescription": "From small VIP groups to large audiences, we provide various bus sizes—from 20 to 50 seaters—so you get exactly what your event requires."
  },
  {
    "WhyChooseheading": "Easy Booking and Full Support",
    "WhyChoosedescription": "Booking a Bus on Rent for Event in Pune is simple with Amruta Travels. Our responsive team helps with booking, scheduling, and coordination every step of the way."
  }
]



























    }

const faqData = [
  {
    question: 'How can I rent a bus for an event in Pune with Amruta Travels?',
    answer: 'Renting a bus for your event in Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We will help you choose the right bus based on your event size and requirements.',
  },
  {
    question: 'What types of buses are available for events in Pune?',
    answer: 'We offer a variety of buses for events, including 32, 35, 45, and 50 seater options. All our buses are equipped with comfortable seating, air conditioning, and ample space for guests or event-related materials.',
  },
  {
    question: 'Can the buses be used for weddings, parties, and other special events?',
    answer: 'Yes, our buses are perfect for transporting guests to weddings, parties, corporate events, and any other special occasions. We ensure comfort, punctuality, and safety throughout the event.',
  },
  {
    question: 'Can I request multiple pickup and drop-off points for the event?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop-off points for your event. Just provide us with the details, and we will plan the best route to suit your needs.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for events?',
    answer: 'Absolutely! All our buses are regularly maintained and sanitized before every trip, ensuring cleanliness, safety, and comfort for your event guests.',
  },
  {
    question: 'How much does it cost to rent a bus for an event in Pune?',
    answer: 'The cost of renting a bus depends on factors like the type of bus, duration, and the specific requirements of your event. Contact us with your event details for a customized quote.',
  },
  {
    question: 'Do you provide drivers with the buses for events?',
    answer: 'Yes, all bus rentals for events come with professional, experienced drivers who ensure timely arrivals, safety, and smooth travel throughout the event.',
  },
  {
    question: 'Can the buses be decorated for events?',
    answer: 'Yes, we can decorate the buses to match the theme of your event. Let us know your preferences, and we’ll ensure the buses complement your event décor.',
  },
  {
    question: 'Why choose Amruta Travels for event bus rentals in Pune?',
    answer: 'Amruta Travels offers reliable, professional service with well-maintained buses and skilled drivers. We specialize in providing event transportation that ensures comfort, punctuality, and a hassle-free experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Kapoor',
    role: 'Event Coordinator, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for our corporate event. The bus was on time, clean, and spacious. The driver was professional, and the entire process was smooth. Highly recommended for event transportation!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Deshmukh',
    role: 'Bride, Pune',
    text: 'We rented a 50-seater bus for our wedding event. The bus was beautifully decorated and very comfortable. The driver was friendly and ensured that our guests were comfortable. Everything was perfect for our big day!',
    rating: 5,
  },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent For Event in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-on-rent-for-event-pune.jpg",
  "description": "Rent buses for events in Pune with Amruta Travels. Offering bus rentals for weddings, parties, and tours including Bhimashankar, Mahabaleshwar, Goa, Shirdi, and more. Choose from 32, 35, 40, 45, and 50-seater buses for your next event in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "50", // Adjust based on per km or flat rate for event bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-for-event-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus on Rent For Event in Pune | Wedding, Party & Tour Bus Rentals | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses on rent for weddings, parties, and events in Pune with Amruta Travels. Rent 32, 35, 40, 45, and 50-seater buses for events, tours to Bhimashankar, Goa, Shirdi, and more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonforeventinpune;